import { IRegion } from '@/creditflowresearch/domain/vo/Region';
import Region from '@/creditflowresearch/domain/Region';
import { hasRegionAccess, type IRegionAccessControl } from '@/creditflowresearch/domain/Region/selectors/hasRegionAccess';

export const selectDefaultRegionId = (
  regionsList: IRegion[],
  accessControl: IRegionAccessControl,
  preferredRegionIds?: string[],
): string => {
  const defaultRegionId = Region.getDefaultId();

  if (!regionsList?.length) {
    return defaultRegionId;
  }

  if (preferredRegionIds?.length) {
    const preferredRegion = regionsList.find((region) => region.id === preferredRegionIds[0]);
    if (preferredRegion && hasRegionAccess(preferredRegion.id, accessControl)) {
      return preferredRegion.id;
    }
  }

  if (hasRegionAccess(defaultRegionId, accessControl)) {
    return defaultRegionId;
  }

  const firstAccessibleRegion = regionsList.find((region) =>
    hasRegionAccess(region.id, accessControl),
  );

  return firstAccessibleRegion?.id || defaultRegionId;
};
